<template>
  <el-dialog :title="$t('housekeepingResource.addResource')" :visible.sync="visible" width="70%" @close="closeDialog">
    <el-form :model="addHousekeepingResourceInfo" label-width="120px" :rules="rules" ref="form">
      <el-form-item :label="$t('housekeepingResource.resourceType')" prop="resTypeId">
        <el-select v-model="addHousekeepingResourceInfo.resTypeId" @change="setAddResTypeName" style="width:100%">
          <el-option v-for="item in addHousekeepingResourceInfo.resourceStoreTypes" :key="item.rstId" :label="item.name"
            :value="item.rstId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.feeType')" prop="feeTypeCd">
        <el-select v-model="addHousekeepingResourceInfo.feeTypeCd" style="width:100%">
          <el-option v-for="item in addHousekeepingResourceInfo.housekeepingFeeTypes" :key="item.feeTypeCd"
            :label="item.typeName" :value="item.feeTypeCd"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.resourceName')" prop="resName">
        <el-input v-model="addHousekeepingResourceInfo.resName"></el-input>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.resourceCode')" prop="resCode">
        <el-input v-model="addHousekeepingResourceInfo.resCode"></el-input>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.costPrice')" prop="costPrice">
        <el-input v-model.number="addHousekeepingResourceInfo.costPrice" type="number"></el-input>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.salePrice')" prop="price">
        <el-input v-model.number="addHousekeepingResourceInfo.price" type="number"></el-input>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.stock')" prop="stock">
        <el-input v-model.number="addHousekeepingResourceInfo.stock" type="number"></el-input>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.supplier')" prop="supplierId">
        <el-row :gutter="10">
          <el-col :span="20">
            <el-select v-model="addHousekeepingResourceInfo.supplierId" @change="setAddSupplierName" style="width:100%">
              <el-option v-for="item in addHousekeepingResourceInfo.resourceSuppliers" :key="item.rsId"
                :label="item.supplierName" :value="item.rsId"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button type="text" @click="_addSupplier">{{ $t('housekeepingResource.addSupplier') }}</el-button>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item :label="$t('housekeepingResource.description')">
        <el-input type="textarea" v-model="addHousekeepingResourceInfo.remark" :rows="3"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveHousekeepingResourceInfo">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveHousekeepingResource, listResourceStoreTypes, listResourceSuppliers, queryHousekeepingFeeType } from '@/api/housekeepingResource/housekeepingResourceApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddHousekeepingResource',
  data() {
    return {
      visible: false,
      addHousekeepingResourceInfo: {
        resId: '',
        resTypeId: '',
        resTypeName: '',
        resourceStoreTypes: [],
        resName: '',
        resCode: '',
        costPrice: '',
        price: '',
        stock: '',
        supplierId: '',
        supplierName: '',
        resourceSuppliers: [],
        remark: '',
        feeTypeCd: '',
        housekeepingFeeTypes: [],
        shopId: getShopId()
      },
      rules: {
        resTypeId: [
          { required: true, message: this.$t('housekeepingResource.requiredResourceType'), trigger: 'blur' }
        ],
        feeTypeCd: [
          { required: true, message: this.$t('housekeepingResource.requiredFeeType'), trigger: 'blur' }
        ],
        resName: [
          { required: true, message: this.$t('housekeepingResource.requiredResourceName'), trigger: 'blur' }
        ],
        resCode: [
          { required: true, message: this.$t('housekeepingResource.requiredResourceCode'), trigger: 'blur' }
        ],
        costPrice: [
          { required: true, message: this.$t('housekeepingResource.requiredCostPrice'), trigger: 'blur' },
          { type: 'number', message: this.$t('housekeepingResource.numberCostPrice'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('housekeepingResource.requiredSalePrice'), trigger: 'blur' },
          { type: 'number', message: this.$t('housekeepingResource.numberSalePrice'), trigger: 'blur' }
        ],
        stock: [
          { required: true, message: this.$t('housekeepingResource.requiredStock'), trigger: 'blur' },
          { type: 'number', message: this.$t('housekeepingResource.numberStock'), trigger: 'blur' }
        ],
        supplierId: [
          { required: true, message: this.$t('housekeepingResource.requiredSupplier'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.visible = true
      this._listAddResourceStoreTypes()
      this._listAddResourceSuppliers()
      this._queryAddHousekeepingFeeTypes()
    },
    closeDialog() {
      this.visible = false
      this.$refs.form.resetFields()
      this.clearAddHousekeepingResourceInfo()
    },

    async saveHousekeepingResourceInfo() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await saveHousekeepingResource(this.addHousekeepingResourceInfo)
            this.$emit('refresh')
            this.$message.success(this.$t('common.saveSuccess'))
            this.closeDialog()
          } catch (error) {
            console.error(error)
          }
        }
      })
    },
    async _listAddResourceStoreTypes() {
      try {
        const res = await listResourceStoreTypes({
          page: 1,
          row: 50,
          shopId: getShopId()
        })
        this.addHousekeepingResourceInfo.resourceStoreTypes = res.data
      } catch (error) {
        console.error(error)
      }
    },
    async _listAddResourceSuppliers() {
      try {
        const res = await listResourceSuppliers({
          page: 1,
          row: 50,
          shopId: getShopId()
        })
        this.addHousekeepingResourceInfo.resourceSuppliers = res.data
      } catch (error) {
        console.error(error)
      }
    },
    async _queryAddHousekeepingFeeTypes() {
      try {
        const res = await queryHousekeepingFeeType({
          page: 1,
          row: 50,
          shopId: getShopId()
        })
        this.addHousekeepingResourceInfo.housekeepingFeeTypes = res.data
      } catch (error) {
        console.error(error)
      }
    },
    _addSupplier() {
      this.$router.push('/pages/goods/resourceSupplierManage?returnFlag=1')
    },
    setAddResTypeName(value) {
      const type = this.addHousekeepingResourceInfo.resourceStoreTypes.find(item => item.rstId === value)
      if (type) {
        this.addHousekeepingResourceInfo.resTypeName = type.name
      }
    },
    setAddSupplierName(value) {
      const supplier = this.addHousekeepingResourceInfo.resourceSuppliers.find(item => item.rsId === value)
      if (supplier) {
        this.addHousekeepingResourceInfo.supplierName = supplier.supplierName
      }
    },
    clearAddHousekeepingResourceInfo() {
      this.addHousekeepingResourceInfo = {
        resId: '',
        resTypeId: '',
        resTypeName: '',
        resourceStoreTypes: this.addHousekeepingResourceInfo.resourceStoreTypes,
        resName: '',
        resCode: '',
        costPrice: '',
        price: '',
        stock: '',
        supplierId: '',
        supplierName: '',
        resourceSuppliers: this.addHousekeepingResourceInfo.resourceSuppliers,
        remark: '',
        feeTypeCd: '',
        housekeepingFeeTypes: this.addHousekeepingResourceInfo.housekeepingFeeTypes,
        shopId: getShopId()
      }
    }
  }
}
</script>